<template lang="pug">
    v-card(class="ma-lg-4 pa-lg-4" flat)
            div.mx-lg-8
                v-row(align="baseline")
                    v-col(cols=12)
                      v-row
                        v-col(cols=12 align="center")
                          p {{ fromLabel }}
                        v-col(cols=12) 
                          AddressFinder(:model="trip.fromAddress" :clear="true" label="Choose a starting location" hint="E.g. Where do you live?")
                    v-col(cols=12)
                        v-row
                          v-col(cols=12)                   
                            div(v-for="(v, index) in trip.viaAddresses" :key="v.id ? v.id : v.osm_id")
                                v-row(align="baseline")
                                    v-col(cols=11) 
                                        AddressFinder(:model="v" :clear="true" label="Where are you stopping?")
                                    v-col(cols=1)
                                        v-btn(fab x-small @click="removeVia(index)" icon tile)
                                            v-icon mdi-close
                            v-row(align="center" justify="center")
                                v-col.spacer(cols=8)
                                    v-btn.ma-lg-4(fab x-small @click="addVia(0)" elevation=2)
                                        v-icon mdi-plus
                                    div.d-inline.my-5 &nbsp;Add a stop
                    v-col(cols=12)
                      v-row
                        v-col(cols=12 align="center")
                          p {{ toLabel }}
                        v-col(cols=12) 
                          AddressFinder(:model="trip.toAddress" :clear="true" label="Choose a destination" hint="E.g. Where do you work?")
 

            
</template>

<script>
import AddressFinder from "./AddressFinder.vue";
import EVNav from "../services/api/EVNav.js";
import TripCardSupport from "../mixins/TripCardSupport.js";
export default {
  props: ["trip", "fromLabel", "toLabel"],
  mixins: [TripCardSupport],
  data() {
    return {
      editing: this.editTitle,
      show: this.expanded,
      panel: [],
      amounts: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
      ],
      units: ["day", "workday", "week", "fortnight", "month", "year"],
      swatchStyle: {
        background: this.colour,
      },
    };
  },
  computed: {
    complete() {
      return this.trip.fromAddress.Address != null && this.trip.toAddress.Address != null;
    },
  },
  components: {
    AddressFinder,
  },
  mounted() {
    this.updateTripData();
  },
  methods: {
    startEditing() {
      if (this.trip.title == "Give this trip a name") {
        this.trip.title = "";
      }
    },
    removeTrip() {
      this.$emit("remove", this.trip);
    },
    makeReturn() {
      this.$emit("makeReturn", this.trip);
    },
    tripFrequency() {
      return this.trip.frequency + " times per " + this.trip.frequencyUnit;
    },
    addVia(index) {
      this.trip.viaAddresses.splice(index, 0, {
        id: this.trip.viaAddresses.length + 1,
      });
    },
    removeVia(index) {
      this.trip.viaAddresses.splice(index, 1);
    },
    updateTripData() {
      if (this.trip.fromAddress.Address != null && this.trip.toAddress.Address != null) {
        EVNav.getDirectRoute(this.trip).then((response) => {
          this.trip.path = [];
          for (let c of response.routes[0].geometry.coordinates) {
            this.trip.path.push([c[1], c[0]]);
          }
          this.trip.distance = response.routes[0].distance;
          this.$emit("tripUpdated");
          return this.trip.path;
        });
      }
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
}
.detail {
  color: #666666;
  font-size: 0.8em;
}
.per {
  font-style: italic;
  text-align: center;
  width: 100%;
  display: block;
}
.spacer {
  height: 24px;
}
.spacer * {
  position: relative;
  top: 50%;
}
.swatch {
  width: 12px;
  height: 12px;
  content: " ";
  display: block;
  background: blue;
}
</style>
